import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import propTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';
import CloseIcon from '@material-ui/icons/Close';
import currentWorklogActions from 'store/currentWorklog/actions';

import styles from './styles';

const SubmittedConfirmModal = ({ classes }) => {
  const dispatch = useDispatch();

  const { isOpen, onFinish } = useSelector((store) => store.currentWorklog.submittedChangesModal);

  const handleClose = () => {
    if (onFinish) onFinish();
    dispatch(currentWorklogActions.closeSubmittedChangesModal());
  }

  const handleSubmit = () => {
    dispatch(currentWorklogActions.openSubmitModal({ modalType: 'Resubmit' }));;
  }

  return (
    <Dialog
      open={isOpen}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        classes: {
          root: classes.dialogRoot
        }
      }}
    >
      <div className={classes.header}>
        <Typography variant="h5" color="textPrimary">
          Work Log Modification Notice
        </Typography>
        <IconButton
          className={classes.closeButton}
          onClick={handleClose}
          aria-label="Close"
          disableRipple
          >
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent style={{ paddingLeft: '20px'}}>
        <Typography variant="body1" color="textSecondary">
          WL modifications have been saved. Would you like to resubmit?
        </Typography>
      </DialogContent>
      <DialogActions>
        <div className={classes.flexBox}>
          <Button
            color="secondary"
            variant="outlined"
            className={classes.cancelButton}
            onClick={handleClose}
            disableTouchRipple
          >
            No
          </Button>
          <Button
            color="primary"
            variant="outlined"
            className={classes.saveButton}
            onClick={handleSubmit}
            disableTouchRipple
          >
            Yes
          </Button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default withStyles(styles)(SubmittedConfirmModal);
